import React, { useEffect, useState } from 'react';
import { Badge, Box, Spinner, Stack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { apiGetArticle, getPdfUrl, getStoredAuth } from '../api/client';
import PortalPageShell from './PortalPageShell';
import PdfViewer from './PdfViewer';
import SubscriptionAccessOverlay from './SubscriptionAccessOverlay';
import useMemberSubscriptionAccess from './useMemberSubscriptionAccess';

export default function ArticleViewPage() {
  const { id } = useParams();
  const articleId = Number(id);
  const [article, setArticle] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { token } = getStoredAuth();
  const {
    hasArticleAccess,
    isExpired,
    latestPayment,
    loadingSubscription,
    subscription,
    subscriptionError,
  } = useMemberSubscriptionAccess();

  useEffect(() => {
    if (!articleId) return;
    apiGetArticle(articleId).then(data => {
      setArticle(data);
      setLoading(false);
    });
  }, [articleId]);

  if (loading || loadingSubscription) {
    return (
      <PortalPageShell title="Article" subtitle="Loading content">
        <Stack align="center" py={12} spacing={4}>
          <Spinner size="xl" color="blue.500" />
          <Text color="gray.600">Loading article...</Text>
        </Stack>
      </PortalPageShell>
    );
  }

  if (!article) {
    return (
      <PortalPageShell title="Article not found">
        <Text color="gray.600">The requested article could not be found.</Text>
      </PortalPageShell>
    );
  }

  const content = (
    <Stack spacing={6}>
      <Badge width="fit-content" colorScheme="blue">
        Article
      </Badge>
      {article.content_type === 'text' ? (
        <Box color="gray.700" lineHeight="tall" dangerouslySetInnerHTML={{ __html: article.body }} />
      ) : (
        <PdfViewer
          file={{
            url: getPdfUrl(article.id),
            httpHeaders: token ? { Authorization: `Bearer ${token}` } : undefined,
          }}
        />
      )}
    </Stack>
  );

  return (
    <PortalPageShell title={article.title} subtitle={article.excerpt || 'Member article details'}>
      {hasArticleAccess ? content : (
        <SubscriptionAccessOverlay
          subscription={subscription}
          latestPayment={latestPayment}
          isExpired={isExpired}
          subscriptionError={subscriptionError}
        >
          {content}
        </SubscriptionAccessOverlay>
      )}
    </PortalPageShell>
  );
}
